import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as BenefitsActions,
  Selectors as BenefitsSelectors,
} from "store/ducks/benefits";

import { Access } from "common";
import {
  Page,
  Panel,
  Loading,
  Breadcrumbs,
  Pagination,
  Button,
} from "components";
import { Filters } from "./components";
import vouchers from "services/vouchers";
import moment from "moment";
import Swal from "sweetalert2";
import fileDownload from "js-file-download";

class List extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Benefícios", to: "/benefits" },
      { name: "Lista de Benefícios", to: "" },
    ],
    filter: {
      store: Access.lockedStore()
        ? Access.lockedStore(true)
        : { value: "", label: "Todos" },
      start_at: null,
      end_at: null,
      type: { value: "", label: "Todos" },
      channel: { value: "", label: "Todos" },
      status: { value: "", label: "Todos" },
      app_only: { value: "", label: "Todos" },
      commercialCampaign: { value: "", label: "Todos" },
      description: "",
    },
    loading: false,
    areFiltersActive: false,
    fileExporting: false,
  };

  componentDidMount() {
    const { filter } = this.state;
    const { filters: filterRecover } = this.props.location;
    const { location, getBenefitsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    if (filterRecover) {
      this.setState({
        filter: filterRecover,
      });
    }

    getBenefitsRequest(page, filter);
    this.checkFiltersActive(filter);
  }

  componentDidUpdate(oldProps, oldState) {
    const { filter, loading } = this.state;
    const { filters: filterRecover } = this.props.location;
    const { location, getBenefitsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      getBenefitsRequest(queryString.parse(location.search).page, filter);
    }

    if (oldProps.location.filters !== undefined && !loading) {
      this.setState({
        filter: filterRecover,
        loading: true,
      });
      getBenefitsRequest(page, filter);
    }

    if (oldState.filter !== filter) {
      this.checkFiltersActive(filter);
    }
  }

  checkFiltersActive = (filter) => {
    const defaultFilter = {
      store: Access.lockedStore()
        ? Access.lockedStore(true)
        : { value: "", label: "Todos" },
      start_at: null,
      end_at: null,
      type: { value: "", label: "Todos" },
      channel: { value: "", label: "Todos" },
      status: { value: "", label: "Todos" },
      app_only: { value: "", label: "Todos" },
      commercialCampaign: { value: "", label: "Todos" },
      description: "",
    };

    const areFiltersActive = Object.keys(defaultFilter).some((key) => {
      if (
        typeof defaultFilter[key] === "object" &&
        defaultFilter[key] !== null
      ) {
        return defaultFilter[key].value !== filter[key].value;
      }
      return defaultFilter[key] !== filter[key];
    });

    if (this.state.areFiltersActive !== areFiltersActive) {
      this.setState({ areFiltersActive });
    }
  };

  handleExport = async () => {
    const { filter } = this.state;

    this.setState({ fileExporting: true });

    vouchers
      .get(`/benefits/_export?${this.createQueryString(filter)}`, {
        timeout: 60000,
        responseType: "blob",
      })
      .then((response) => {
        fileDownload(response.data, `benefits-${moment().format()}.csv`);
      })
      .catch(() => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro durante a exportação dos clientes PRO, tente novamente mais tarde.",
          type: "error",
          confirmButtonText: "Ok",
        });
      })
      .finally(() => this.setState({ fileExporting: false }));
  };

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;
    const { getBenefitsRequest } = this.props;

    const newFilter = { ...filter, [name]: value };
    this.setState({ filter: newFilter });
    getBenefitsRequest(1, newFilter);
  };

  handleClean = async (e) => {
    e.preventDefault();
    const { getBenefitsRequest } = this.props;

    const defaultFilter = {
      store: Access.lockedStore()
        ? Access.lockedStore(true)
        : { value: "", label: "Todos" },
      start_at: null,
      end_at: null,
      type: { value: "", label: "Todos" },
      channel: { value: "", label: "Todos" },
      status: { value: "", label: "Todos" },
      app_only: { value: "", label: "Todos" },
      commercialCampaign: { value: "", label: "Todos" },
      description: "",
    };

    this.setState({ filter: defaultFilter });
    getBenefitsRequest(1, defaultFilter);
  };

  createQueryString = (filters) => {
    const store_id =
      filters.store.value !== "" ? `&store_id=${filters.store.value}` : "";
    const start_at =
      filters.start_at !== null
        ? `&start_at=${moment(filters.start_at).format("YYYY-MM-DD")}`
        : "";
    const end_at =
      filters.end_at !== null
        ? `&end_at=${moment(filters.end_at).format("YYYY-MM-DD")}`
        : "";
    const category_id =
      filters.type.value !== "" ? `&category_id=${filters.type.value}` : "";
    const channel =
      filters.channel.value !== ""
        ? `&channel_id=${filters.channel.value}`
        : "";
    const status =
      filters.status.value !== "" ? `&status=${filters.status.value}` : "";
    const app_only =
      filters.app_only.value !== ""
        ? `&extra_data[app_only]=${filters.app_only.value}`
        : "";
    const commercialCampaign =
      filters.commercialCampaign.value !== ""
        ? `&campaign_id=${filters.commercialCampaign.value}`
        : "";
    const description = filters.description
      ? `&description=${filters.description}`
      : "";

    return `${store_id}${start_at}${end_at}${category_id}${channel}${status}${app_only}${commercialCampaign}${description}`;
  };

  render() {
    const { breadcrumbs, filter, areFiltersActive } = this.state;
    const { benefits } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Benefícios</Page.Title>

        <Filters
          filter={filter}
          onChange={this.handleChangeFilter}
          onClean={this.handleClean}
        />

        <Panel className="panel-list">
          {Access.hasPermissions("edit-benefits") && (
            <Link to="/benefits/create" className="button-add margin-bottom-20">
              Adicionar Benefício
            </Link>
          )}

          {!benefits.data.length && benefits.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {benefits.loading && <Loading type="table" size="x-large" />}

              <p className="benefits-quantity">
                Quantidade de Benefícios:{" "}
                {benefits.total_benefits ? benefits.total_benefits : 0}
              </p>

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>Titulo</th>
                    <th>Pontos</th>
                    <th>Tipo</th>
                    <th>Loja</th>
                    <th>Período</th>
                    <th>Tipo</th>
                    <th>Situação</th>
                    <th className="text-right">Ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!benefits.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {benefits.data.map((benefit, index) => (
                    <tr key={String(benefit.id)}>
                      <td>{benefit.attributes.title}</td>
                      <td>{benefit.attributes.value}</td>
                      <td>
                        {benefit.attributes.voucher_configuration !== null
                          ? benefit.attributes.voucher_configuration.title
                          : "-"}
                      </td>
                      <td>{benefit.attributes.stores}</td>
                      <td>{benefit.attributes.period}</td>
                      <td>{benefit.attributes.category}</td>
                      <td className={benefit.attributes.status.className}>
                        {benefit.attributes.status.label}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions("edit-benefits") && (
                          <Link
                            to={{
                              pathname: `/benefits/${benefit.id}/edit`,
                              filters: filter,
                            }}
                            className="button-icon"
                          >
                            <span className="glyph glyph-eye" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="8" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={benefits.page}
                total={benefits.totals}
                {...this.props}
              />

              {Access.hasPermissions("edit-benefits") && (
                <Link to="/benefits/create" className="button-add">
                  Adicionar Benefício
                </Link>
              )}

              <Button
                className="button-export"
                disabled={!areFiltersActive}
                onClick={() => this.handleExport()}
              >
                Exportar
              </Button>
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  benefits: {
    ...state.benefits,
    data: BenefitsSelectors.benefits(state.benefits.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(BenefitsActions, dispatch);

export default connect(mapState, mapActions)(List);
